import gql from 'graphql-tag';

export default gql`
  fragment seatPriceFragment on SeatOrderItem {
    seatPrice {
      subtotal
      taxes {
        breakdown {
          name
          code
          value {
            amount
          }
        }
        total {
          amount
          currency
        }
      }
      taxesIncludedInBundle {
        breakdown {
          name
          code
          value {
            amount
          }
        }
        total {
          amount
          currency
        }
      }
      total
      isUpgradePrice
    }
  }
`;
